import React from "react";

import { NewTab, PageTab } from "../../../../components";
import InternalDb from "../../CommonJobBoards/InternalDb";
import CareerBuilder from "../../CommonJobBoards/CareerBuilder";
import Monster from "../../CommonJobBoards/Monster";
import KultSearch from "../../CommonJobBoards/KultSearch";
import IntegratedSearch from "../../CommonJobBoards/IntegratedSearch";
import { resetIntegratedSearch, revertStateLoading } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch } from "react-redux";

const JobBoards = () => {
  const dispatch = useDispatch();
  const jobBoardMenus = [
    {
      title: "Internal DB",
      page: <InternalDb />,
      type: "main",
      id: "applicants_jobboards_internaldb",
    },
    {
      title: "Career Builder",
      page: <CareerBuilder />,
      type: "main",
      id: "applicants_jobboards_careerbuilder",
    },
    {
      title: "Monster",
      page: <Monster />,
      type: "main",
      id: "applicants_jobboards_monster",
    },
    // {
    //   title: "Kult Search",
    //   page: <KultSearch />,
    //   type: "main",
    //   id: "applicants_jobboards_kultsearch",
    // },
    {
      title: "Integrated Search",
      page: <IntegratedSearch />,
      type: "main",
      id: "applicants_jobboards_integratedsearch",
    },
  ];
  const handleChange = (selectedTab) => {
    // console.log("Selected tab:", selectedTab);
    dispatch(resetIntegratedSearch());
    dispatch(revertStateLoading());
  };
  return (
    <div className="flex-1 flex flex-col overflow-hidden my-3">
      <NewTab
        tabs={jobBoardMenus}
        color="gray"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="applicants-jobboards"
        onTabChange={handleChange}
      />
    </div>
  );
};

export default JobBoards;
